// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hpa-metrics-table .info-box[data-v-286ca09f]{background-color:var(--simple-box-bg)}.hpa-metrics-table .row .over-hr[data-v-286ca09f]{padding-right:30px}", ""]);
// Exports
module.exports = exports;
